import React from 'react';
import '../../scripts/Scenes/script.css';

// The same detached, read-only scene HTML used in Scene Breakdown.
export default function SceneScreenplay({ scene }) {
  return <div className="scriptHolder pp-script-view pp-scene-script" aria-label={`Screenplay text for scene ${scene.number}`} aria-readonly="true" dangerouslySetInnerHTML={{ __html: scene.html || '' }} />;
}